export const ROOM_STATUS = { en: 'Room status', th: 'สถานะที่พัก' }

export const PLACE_DETAIL = { en: 'Place detail', th: 'รายละเอียดที่พัก' }

export const RENTAL_PRICE = { en: 'Rental price', th: 'ราคาเช่า' }

export const BROKER_STATUS = { en: 'Status', th: 'สถานะนายหน้า' }

export const BROKER_STATUS_PENDING = { en: 'Pending', th: 'รออนุมัติ' }

export const BROKER_STATUS_APPROVED = { en: 'Approved', th: 'อนุมัติแล้ว' }

export const DEALS = { en: 'Deals', th: 'ห้องที่เคยปล่อยเช่า' }

export const DEALS_DETAIL = { en: 'Details', th: 'รายละเอียด' }

export const SEE_PLACE_DETAILS = {
  en: 'See place details',
  th: 'ดูรายละเอียดที่พัก',
}

export const CANCEL_REQUEST = { en: 'Cancel request', th: 'ยกเลิกคำขอ' }

export const CANCEL_REQUEST_MODAL_TITLE = {
  en: 'Confirm Cancel Request',
  th: 'ยืนยันการยกเลิกคำขอ',
}

export const CANCEL_REQUEST_MODAL_DESCRIPTION = {
  en: 'Are you sure you want to cancel this request?',
  th: 'คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำขอนี้',
}

export const CANCEL_REQUEST_SUCCESS_MESSAGE = {
  en: 'Your request has been cancelled',
  th: 'คำขอของคุณได้ถูกยกเลิกแล้ว',
}

export const OWNER = { en: 'Owner', th: 'เจ้าของที่พัก' }

export const OWNER_CONTACT = {
  en: 'Owner’s contact',
  th: 'ติดต่อเจ้าของที่พัก',
}

export const PLACE_RATING = { en: 'Place rating', th: 'คะแนนที่พัก' }

export const DEAL_COUNTS = { en: 'Deal counts', th: 'จำนวนครั้งที่ปล่อยเช่า' }

export const REQUEST_DATE = {
  en: 'Request to be broker',
  th: 'วันที่ขอเป็นนายหน้า',
}

export const APPROVAL_DATE = { en: 'Approval date', th: 'วันที่ได้รับอนุมัติ' }
